"use client";
import React from 'react';

export default function TermsOfUse() {
  const container: React.CSSProperties = {
    maxWidth: 900,
    margin: '40px auto',
    padding: '0 16px',
    lineHeight: 1.6,
    color: '#111827'
  };
  const h1: React.CSSProperties = { fontSize: '2rem', marginBottom: 12, fontWeight: 800 };
  const p: React.CSSProperties = { margin: '10px 0' };
  const small: React.CSSProperties = { color: '#6b7280', fontSize: '0.9rem' };

  return (
    <main style={container}>
      <h1 style={h1}>Terms of Use</h1>
      <p style={small}>
        Note: This is a placeholder Terms of Use page. Replace this content with your official legal terms
        reviewed by counsel. The Legal Disclaimer modal links here by default: <code>/terms-of-use</code>.
      </p>

      <p style={p}>
        By accessing or using this interface, you agree to these Terms of Use. If you do not agree to these
        Terms, you must not use this interface.
      </p>

      <h2>1. No Warranties</h2>
      <p style={p}>
        The interface and related materials are provided on an “as is” and “as available” basis without
        warranties of any kind, whether express or implied, including without limitation warranties of
        merchantability, fitness for a particular purpose, and non-infringement.
      </p>

      <h2>2. Assumption of Risk</h2>
      <p style={p}>
        Accessing and using blockchain-based protocols involves risks that may result in substantial losses.
        You acknowledge and agree that you assume all risks associated with your use of this interface.
      </p>

      <h2>3. Prohibited Jurisdictions</h2>
      <p style={p}>
        This interface is not offered to persons or entities located, incorporated, organized in, or residents
        or citizens of certain jurisdictions. If you are in a prohibited jurisdiction, you must not use this interface.
      </p>

      <h2>4. No Solicitation</h2>
      <p style={p}>
        Nothing in this interface constitutes investment, legal, or other advice, nor is it a solicitation or
        inducement to engage in any financial activity.
      </p>

      <h2>5. Updates</h2>
      <p style={p}>
        We may revise these Terms from time to time. Your continued use of the interface constitutes acceptance
        of the revised Terms.
      </p>

      <p style={{ ...p, marginTop: 20, ...small }}>
        Replace this page with your official Terms of Use document. Location: <code>src/pages/TermsOfUse.tsx</code>.
      </p>
    </main>
  );
}